<template>
    <div class="container-fluid" style="background-color: white">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <br/>
                <form class="form-inline my-2 my-lg-0">
                    <date-picker
                        :lang="lang"
                        type="month"
                        :format="changeFormat"
                        v-model="search.date"
                        placeholder="ค้นหาเดือน-ปี"
                        @change="changeDate"
                        format="MM/YYYY">
                    </date-picker>
                    &nbsp
                    <button @click="searchRealizedGainLoss"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="printRealizedGainLoss"
                            :disabled="!file_url"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์รายงาน
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>รายการ</th>
                </tr>
                </thead>
                <tbody style="text-align: left">
                <tr>
                    <td>
                        รายได้จากการดำเนินงาน (TN)
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_invoice.invoice">
                                <tr>
                                    <td style="text-align: left">- {{ data.product_type_name }}</td>
                                    <td width="300px" class="text-right">{{ data.total ? data.total : 0 | currency }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวมขายสินค้า</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.total ? form.sum_invoice.total : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>ค่าขนส่ง</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.transport_fee ? form.sum_invoice.transport_fee : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>ส่วนลดโปรโมชั่น</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.discount ? form.sum_invoice.discount : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>ส่วนลดอื่นๆ</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.discount_other ? form.sum_invoice.discount_other : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>ส่วนลดมารับเอง (แก้ว , โฟม)</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.discount_special ? form.sum_invoice.discount_special : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>หักจ่ายเกินคราวก่อน</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.sum_credit ? form.sum_invoice.sum_credit : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>รับคืนสินค้า</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.cash_back ? form.sum_invoice.cash_back : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>รวมสุทธิ</td>
                                <td class="text-right">
                                    {{ form.sum_invoice.sum_total ? form.sum_invoice.sum_total : 0 | currency }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        รายได้อื่นๆ
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_rvo.data">
                                <tr>
                                    <td style="text-align: left">- {{ data.code }} {{ data.name }}</td>
                                    <td width="300px" class="text-right">{{ data.total ? data.total : 0 | currency }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td class="text-right">{{ form.sum_rvo.total ? form.sum_rvo.total : 0 | currency }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        รายจ่ายซื้อวัตถุดิบ(ต้นทุนการขาย)
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_cs.data">
                                <template v-if="data.material_type">
                                    <tr>
                                        <td style="text-align: left">- {{ data.material_type_name }}</td>
                                        <td width="300px" class="text-right">
                                            {{ data.total ? data.total : 0 | currency }}
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td style="text-align: left">- วัตถุดิบอื่นๆ</td>
                                        <td width="300px" class="text-right">
                                            {{ data.total ? data.total : 0 | currency }}
                                        </td>
                                    </tr>
                                </template>
                            </template>
                            <tr>
                                <td style="text-align: left">
                                    -{{ form.sum_50060 ? form.sum_50060.account_number : '' }}
                                    {{ form.sum_50060 ? form.sum_50060.name : '' }}
                                </td>
                                <td width="300px" class="text-right">
                                    {{ form.sum_50060 ? form.sum_50060.total : 0 | currency }}
                                </td>
                            </tr>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td class="text-right">
                                    {{ sumCs | currency }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        สินทรัพย์
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_cs_account_1.data">
                                <tr>
                                    <td style="text-align: left">- {{ data.account_number }} {{ data.name }}</td>
                                    <td width="300px" class="text-right">{{ data.total ? data.total : 0 | currency }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td>{{ form.sum_cs_account_1.total ? form.sum_cs_account_1.total : 0 | currency }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        หนี้สิน
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_cs_account_2.data">
                                <tr>
                                    <td style="text-align: left">- {{ data.account_number }} {{ data.name }}</td>
                                    <td width="300px" class="text-right">{{ data.total ? data.total : 0 | currency }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td>{{ form.sum_cs_account_2.total ? form.sum_cs_account_2.total : 0 | currency }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        ทุน
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_cs_account_3.data">
                                <tr>
                                    <td style="text-align: left">- {{ data.account_number }} {{ data.name }}</td>
                                    <td width="300px" class="text-right">{{ data.total ? data.total : 0 | currency }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td>{{ form.sum_cs_account_3.total ? form.sum_cs_account_3.total : 0 | currency }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        ค่าใช้จ่ายอื่นๆ
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_cs_other.data">
                                <tr>
                                    <td style="text-align: left">- {{ data.account_number }} {{ data.name }}</td>
                                    <td width="300px" class="text-right">{{ data.total ? data.total : 0 | currency }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td>{{ form.sum_cs_other.total ? form.sum_cs_other.total : 0 | currency }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        ชำระหนี้โครงการ
                        <table class="table table-bordered">
                            <template v-for="data in form.sum_cs_project.data">
                                <tr>
                                    <td style="text-align: left">- {{ data.main_name }} {{ data.sub_name }}</td>
                                    <td width="300px">{{ data.total ? data.total : 0 | currency }}</td>
                                </tr>
                            </template>
                            <tr class="text-right font-weight-bold">
                                <td>รวม</td>
                                <td>{{ form.sum_cs_project.total ? form.sum_cs_project.total : 0 | currency }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        เงินเดือนพนักงาน
                        <table class="table table-bordered">
                            <tr>
                                <td style="text-align: left">
                                    {{ form.sum_salary_employee ? form.sum_salary_employee.month : '' }}
                                </td>
                                <td width="300px">
                                    {{ form.sum_salary_employee ? form.sum_salary_employee.total : 0 | currency }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        รายละเอียดเพิ่มเติม
                        <table class="table table-bordered">
                            <tr>
                                <td style="text-align: left">ยอดหนี้คงค้าง ณ เดือน
                                    {{ form.sum_salary_employee ? form.sum_salary_employee.month : '' }}
                                </td>
                                <td width="300px" class="text-right">
                                    {{ form.invoice_remaining ? form.invoice_remaining.total : 0 | currency }}
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align: left">
                                    เช็ครับล่วงหน้าที่ยังไม่เข้า BANK
                                </td>
                                <td width="300px" class="text-right">
                                    {{ form.cheque_b ? form.cheque_b.total : 0 | currency }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table class="table table-bordered font-weight-bold">
                            <tr>
                                <td class="text-right">
                                    รวมรายได้ทั้งหมด :
                                    {{ form.sum_income ? form.sum_income : 0 | currency }}
                                </td>
                                <td class="text-right">
                                    รวมรายจ่ายทั้งหมด :
                                    {{ form.sum_expend ? form.sum_expend : 0 | currency }}
                                </td>
                                <td class="text-right">
                                    กำไร - ขาดทุน :
                                    {{ form.remaining ? form.remaining : 0 | currency }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal ref="loading" hide-header hide-footer>
            <loading @submit="hideLoadingModal" :msg="msg" :status="status_loading"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Loading from "../../Utility/Loading";

export default {
    name: "realized-gain-loss-form",
    components: {
        Loading,
        DatePicker
    },
    created() {
        this.getCurrentMonthYear();
    },
    data() {
        return {
            file_url: null,
            status_loading: '',
            msg: '',
            search: {
                date: ""
            },
            month: "",
            year: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.RealizedGainLoss.realized_form
            }
        }),
        sumCs() {
            let sum_cs = 0;
            let sum_50060 = 0;
            if (this.form.sum_cs && this.form.sum_cs.total) {
                sum_cs = parseFloat(sum_cs) + parseFloat(this.form.sum_cs.total);
            }
            if (this.form.sum_50060 && this.form.sum_50060.total) {
                sum_50060 = parseFloat(sum_50060) + parseFloat(this.form.sum_50060.total);
            }
            return parseFloat(sum_cs) + parseFloat(sum_50060);
        }
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        printRealizedGainLoss() {
            this.file_url = this.form.file_url;
            window.open(this.file_url, '_blank');
        },
        searchRealizedGainLoss() {
            let month = "";
            let year = "";
            if (this.search.date) {
                this.msg = "กรุณารอสักครู่";
                this.status_loading = 1;
                this.showLoadingModal();
                month = moment(this.search.date).format("MM");
                year = moment(this.search.date).format("YYYY");
                this.$store.dispatch("RealizedGainLoss/getRealizedGainLossPerMonth", {
                    month: month,
                    year: year
                }).then(() => {
                    this.file_url = this.form.file_url;
                    this.hideLoadingModal();
                }).catch(() => {
                    this.msg = "ค้นหาข้อมูลไม่สำเร็จ กรุณารอสักครู่";
                    this.status_loading = 3
                });
            } else {
                alert('กรุณาเลือกวันที่')
            }
        },
        changeDate() {
            this.file_url = null;
        },
        getCurrentMonthYear() {
            this.month = new Date().getMonth() + 1;
            this.year = new Date().getFullYear();
            this.$store.dispatch("RealizedGainLoss/getRealizedGainLossPerMonth", {
                month: this.month,
                year: this.year
            }).then(() => {
                this.file_url = this.form.file_url;
            });
        },
    }
}
</script>

<style scoped>
thead {
    background-color: gainsboro;
    color: #000;
}

tbody {
    background-color: white;
    color: black;
}
</style>
